import { render, staticRenderFns } from "./TabTasks.vue?vue&type=template&id=8ec6a7f8"
import script from "./TabTasks.vue?vue&type=script&lang=ts"
export * from "./TabTasks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports